<script>
import Vue from 'vue'
import Component from 'vue-class-component'

@Component({
    props: {
        completedObservations: Number,
        expectedObservations: Number,
        observationsToDatePercentage: String
    }
})

export default class CaseloadDoughnut extends Vue {
    
}
</script>

<template>
    <div class="caseload-doughnut">
        <h2>Observations To Date</h2>
        <svg width="100%" height="80%" viewBox="0 0 42 42" class="donut">
            <circle class="donut-hole"
                cx="21"
                cy="18"
                r="15.91549430918954"
                fill="#fff" />
            <circle class="donut-ring"
                cx="21"
                cy="18"
                r="15.91549430918954"
                fill="transparent"
                stroke="#d2d3d4"
                stroke-width="3" />
            <circle class="donut-segment"
                cx="21"
                cy="18"
                r="15.91549430918954"
                fill="transparent"
                stroke="#613f75"
                stroke-width="3"
                :stroke-dasharray="`${observationsToDatePercentage} ${100 - observationsToDatePercentage}`"
                stroke-dashoffset="75" />
            <text x="50%"
                y="50%"
                text-anchor="middle">
                {{ observationsToDatePercentage }}%
            </text>
            <text x="50%"
                y="100%"
                text-anchor="middle">
                {{ `${completedObservations}/${expectedObservations} Complete` }}
            </text>
        </svg>
    </div>
</template>

<style lang="scss" scoped>
    .caseload-doughnut {
        border: 1px solid #979797;
        padding: 0 10%;
        text-align: center;
        margin-right: 106px;
        h2 {
            margin-bottom: 0;
            font-weight: 500;
            font-family: 'museo_sans';
        }
        svg {
            text {
                font-family: 'museo_sans';
                font-weight: 500;
                color: #4a4a4a;
                &:nth-of-type(1) {
                    font-size: 0.3em;
                    -moz-transform: translateY(-0.25em);
                    -ms-transform: translateY(-0.25em);
                    -webkit-transform: translateY(-0.25em);
                    transform: translateY(-0.25em);
                }
                &:nth-of-type(2) {
                    font-size: 0.23em;
                }
            }
        }
    }
</style>
